//
import Model from '@/models/Model'
import GBank from '@/models/General/GBank'

/**
 * This class describes a pch provider payment position payment type.
 *
 * @class      PchProviderPaymentPosPaymentType (name)
 */
export default class PchProviderPaymentPosPaymentType extends Model {

  get bank_id() {
    return this.transformed_data.g_bank_id
  }

  getBank() {
    if (this.bank_id) {
      GBank.find(this.bank_id).then(res => {
        this.bank = res
        this.account_number = `${ res.bank } - ${ this.account_number }`
      })
    }
  }

  reset() {

    //
    this.data_parsed = JSON.parse(this.data || '{}')

    //
    this.payment_type = this.getProperty('pos_sale_payment_type.type', '')
    this.account_number = this.getProperty('data_parsed.account_number', null) || this.getProperty('data_parsed.account', null) || '-'
    this.plaza = this.getProperty('data_parsed.plaza', '-')
    this.charge_date = this.getProperty('data_parsed.charge_date', '-')
    this.serial_number = this.getProperty('data_parsed.serial_number', '-')

    //
    this.getBank()

    //
    return this
  }

  /**
   * { function_description }
   *
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'pch_provider_payment_pos_payment_type'
  }
}
